import 'react-toastify/dist/ReactToastify.css';
import './app.scss';
import 'app/config/dayjs';

import React, { useEffect } from 'react';
import { BrowserRouter } from 'react-router-dom';

import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getSession } from 'app/shared/reducers/authentication';
import { getProfile } from 'app/shared/reducers/application-profile';
import Footer from 'app/shared/layout/footer/footer';
import { hasAnyAuthority } from 'app/shared/auth/private-route';
import ErrorBoundary from 'app/shared/error/error-boundary';
import { AUTHORITIES } from 'app/config/constants';
import AppRoutes from 'app/routes';
import MainLayout from 'app/main/layout';
import EntryAppRoutes from 'app/entry-routes';
import { ToastProvider } from 'app/context/ToastContext';
import MainClientLayout from 'app/main/client-layout';
import ClientAppRoutes from 'app/client-routes';

const baseHref = document.querySelector('base').getAttribute('href').replace(/\/$/, '');

export const App = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(getSession());
    dispatch(getProfile());
  }, []);

  const isAuthenticated = useAppSelector(state => state.authentication.isAuthenticated);
  const isAdmin = useAppSelector(state => hasAnyAuthority(state.authentication.account.authorities, [AUTHORITIES.ADMIN]));
  const isAdminOrAgentOrAssistant = useAppSelector(state =>
    hasAnyAuthority(state.authentication.account.authorities, [
      AUTHORITIES.ADMIN,
      AUTHORITIES.ASSISTANT,
      AUTHORITIES.AGENT,
      AUTHORITIES.SUPER_ADMIN,
    ]),
  );
  const ribbonEnv = useAppSelector(state => state.applicationProfile.ribbonEnv);
  const isInProduction = useAppSelector(state => state.applicationProfile.inProduction);
  const isOpenAPIEnabled = useAppSelector(state => state.applicationProfile.isOpenAPIEnabled);
  const account = useAppSelector(state => state.authentication.account);

  const getContent = () => {
    if (account?.isAuthenticated && isAdminOrAgentOrAssistant) {
      return (
        <>
          <ErrorBoundary>
            <MainLayout>
              <AppRoutes />
            </MainLayout>
          </ErrorBoundary>
          <Footer />
        </>
      );
    } else if (account?.isAuthenticated) {
      return (
        <>
          <ErrorBoundary>
            <MainClientLayout>
              <ClientAppRoutes />
            </MainClientLayout>
          </ErrorBoundary>
          <Footer />
        </>
      );
    } else if (account?.isAuthenticated === false) {
      return (
        <>
          <ErrorBoundary>
            <EntryAppRoutes />;
          </ErrorBoundary>
          <Footer />
        </>
      );
    }
    return <div />;
  };

  return (
    <BrowserRouter basename={baseHref}>
      <ToastProvider>{getContent()}</ToastProvider>
    </BrowserRouter>
  );
};

export default App;
